import * as React from "react";
import { Button, Container, Grid, Header } from "semantic-ui-react";

import { AnsweredQuestionWithId, OhCase } from "../../model";
import { TaskModel } from "../../task/taskActions/models";
import {
    DATE_FORMAT,
    getQuestionnaireForm,
    ManagerSatisfactionFollowUpQuestionnaireRequestDto,
    QuestionnaireFormProps
} from "../models";

interface Props {
    ohCase: OhCase;
    task: TaskModel;
    reportLink: string;
    request: ManagerSatisfactionFollowUpQuestionnaireRequestDto;
    questions: AnsweredQuestionWithId[];
    submitQuestionnaire?: (questions: AnsweredQuestionWithId[]) => Promise<boolean>;
}

export const ManagerSatisfactionFollowUpQuestionnaire: React.FunctionComponent<Props> = (props: Props) => {

    const questionnaireFormProps: QuestionnaireFormProps = {
        ohCase: props.ohCase,
        task: props.task,
        questions: props.questions,
        submitQuestionnaire: props.submitQuestionnaire
    };

    const questionnaire = getQuestionnaireForm(props.request.questionnaireType, questionnaireFormProps);

    return (
        <Container className="referral-report">
            <Grid container>
                <Grid.Row className="report-title-row">
                    <Grid.Column>
                        <Header as="h1">Manager Satisfaction Follow Up Questionnaire</Header>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Grid container className="details-grid">
                <Grid.Row className="report-section-row">
                    <Grid.Column>
                        <Header as="h4">Details</Header>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column className="primary-column" computer={6} mobile={16}>
                        Employee
                    </Grid.Column>
                    <Grid.Column computer={10} mobile={16}>
                        {props.ohCase?.employeeFirstName} {props.ohCase?.employeeLastName}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column className="primary-column" computer={6} mobile={16}>
                        Date of Report
                    </Grid.Column>
                    <Grid.Column computer={5} mobile={16}>
                        {props.request?.reportCompletedDate?.isValid() && props.request?.reportCompletedDate?.format(DATE_FORMAT)}
                    </Grid.Column>
                    <Grid.Column computer={5} mobile={16} textAlign="right">
                        <a
                            href={props.reportLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button type="button" content="Open Report" />
                        </a>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Container>
                <Grid>
                    {questionnaire}
                </Grid>
            </Container>
        </Container>
    );
};
